import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import PubSub from 'pubsub-js';
import { getLinkUrl } from '../services/appservice';
import './ItemEditForm.css';
import { ApplicationState } from '../store';
import * as AppStore from '../store/AppDataContainer';
import { getItemDetails} from '../services/appservice';

const queryString = require('query-string');

const ItemEdit = (props: any) => {
    const appState = useSelector(state => state) as ApplicationState;
    const [queryStingDetails, setQueryStingDetails] = useState({ m: 'r' });
    const [relatedTemplateList, setRelatedTemplateList] = useState([] as AppStore.RelatedTemplates[]);

    const onCloseModal = () => {
        if (queryStingDetails && queryStingDetails.m === "e") {
            queryStingDetails.m = "r";            
        }
        var currentQueryParams = queryString.stringify(queryStingDetails)
        let url = window.location.origin + window.location.pathname + "?" + currentQueryParams;
        window.location.href = url;
    };
    const styles = {
        fontFamily: "sans-serif",
        textAlign: "center",
        minHeight: "1000px",
        minWidth: "1000px",
        maxWidth: "100%",
        border: "0",
        width: "100%"
    };
    const hidden = {
        display: "none"
    };
    const show = {
        display: ""
    };

    const btnToggleClick = () => {
        PubSub.publish('ItemEdit_LoadItemLink', props);
    };

    const btnTemplateClick = () => {
        let linkData = { "application": "experience", "pagetype": "itemdashboard", "collectionid": "", "override": "true", "itemid": "", "fields":"TemplateContentNS,TemplateContentHTML" };
        var components: AppStore.ESComponent[] = props.SiteConfiguration.Components;
        var comp = components.find(t => t.InstanceId === props.component.Id);
        if (comp && comp.CollectionId && comp.Id) {
            linkData.collectionid = comp.CollectionId;
            linkData.itemid = comp.Id;
            PubSub.publish('ItemEdit_LoadItemLink', linkData);
        }        
    };

    const btnStyleClick = () => {
        let linkData = { "application": "experience", "pagetype": "itemdashboard", "collectionid": "", "override": "true", "itemid": "", "fields": "StyleContent,StyleContentMinified" };
        var components: AppStore.ESComponent[] = props.SiteConfiguration.Components;
        var comp = components.find(t => t.InstanceId === props.component.Id);
        if (comp && comp.ComponentStyle && comp.ComponentStyle.length > 0 && comp.ComponentStyle[0].CollectionId && comp.ComponentStyle[0].Id) {
            linkData.collectionid = comp.ComponentStyle[0].CollectionId;
            linkData.itemid = comp.ComponentStyle[0].Id;
            PubSub.publish('ItemEdit_LoadItemLink', linkData);
        }
    };

    const getTemplateDataSuccessHandler = (data: any) => {
        if (data.data) {
            console.log(data);
            let esComponentList: AppStore.ESComponent[] = props.SiteConfiguration.Components;
            if (esComponentList && esComponentList.length > 0) {
                let selectedTemplate = esComponentList.find(t => t.InstanceId === data.data.Template.Key);
                if (!selectedTemplate) {
                    let templateComponent: AppStore.ESComponent = {};
                    templateComponent.CollectionId = data.data.Template.CollectionId;
                    templateComponent.Id = data.data.Template.Id;
                    templateComponent.InstanceId = data.data.Template.Key;
                    templateComponent.MockData = data.data.Template.DynamicProperties.MockData;
                    templateComponent.TemplateContentNS = data.data.Template.DynamicProperties.TemplateContentNS;
                    templateComponent.TemplateContent = data.data.Template.DynamicProperties.TemplateContent;
                    let componentStyle: AppStore.ESComponentStyle = {};
                    componentStyle.CollectionId = data.data.Style.CollectionId;
                    componentStyle.Id = data.data.Style.Id;
                    componentStyle.Key = data.data.Style.Key;
                    componentStyle.Style = data.data.Style.DynamicProperties.StyleContentMinified;
                    templateComponent.ComponentStyle = [componentStyle];
                    esComponentList.push(templateComponent);
                }
            }
            PubSub.publish('ItemEdit_TemplateChanged_' + props.component.Id, { 'component': props.component, 'AssociatedTemplate' : data.data });
        }
    }

    const btnRelatedTempltesClick = (e: any, template: AppStore.RelatedTemplates) => {
        var request: AppStore.KeyValue;
        request = { ...template };
        if (appState && appState.appStore && appState.appStore.ContextData) {
            let server = appState.appStore.ContextData.find(t => t.path === "AppSettings:XPAPIServer").value;
            getItemDetails(server, request, getTemplateDataSuccessHandler);
        }        
    };

    

    useEffect(() => {
        var page = window.location.pathname.substring(1);
        var parsed = queryString.parse(window.location.search);
        setQueryStingDetails(parsed);
        let layoutComponents: AppStore.ESComponent[] = props && props.SiteConfiguration && props.SiteConfiguration.Components ? props.SiteConfiguration.Components : [];
        if (layoutComponents !== undefined && layoutComponents.length > 0) {
            let relatedComponent = layoutComponents.filter(t => t.InstanceId === props.component.Id);
            if (relatedComponent && relatedComponent.length > 0) {
                let relatedTemplates = relatedComponent[0].RelatedTemplates;
                if (relatedTemplates && relatedTemplates.length > 0) {
                    setRelatedTemplateList([...relatedTemplates]);
                }
            }
        }
        
    }, []);

    const isEditMode = (): boolean => {
        if (queryStingDetails && queryStingDetails.m === "e") {
            return true;
        }
        return false;
    }

    const onTemplateClick = (e: any, templateName: any): any => {
        console.log(templateName);    
        PubSub.publish('ItemEdit_TemplateChanged_' + props.component.Id, { 'component': props.component, templateName });
    }

    return (
        isEditMode() ?
            <React.Fragment>
                <div className={props.className !== "" ? props.className + " btn-group btn-edit-menu" : "btn-group btn-edit-menu"} role="group" aria-label="...">
                    <button type="button" className="btn btn-default" title="Edit" onClick={btnToggleClick} data-toggle="modal" data-target="#modalForm" data-backdrop="static" data-keyboard="false">
                        <i className="fa fa-pencil btn-edit-toolbar" aria-hidden="true"></i>
                    </button>
                    <button type="button" className="btn btn-default" title="Template" onClick={btnTemplateClick} data-toggle="modal" data-target="#modalForm" data-backdrop="static" data-keyboard="false">
                        <i className="fa fa-html5 btn-edit-toolbar" aria-hidden="true"></i>
                    </button>
                    <button type="button" className="btn btn-default" title="Style" onClick={btnStyleClick} data-toggle="modal" data-target="#modalForm" data-backdrop="static" data-keyboard="false">
                        <i className="fa fa-css3 btn-edit-toolbar" aria-hidden="true"></i>
                    </button>        
                    {relatedTemplateList.length > 0 && 
                        <div className="dropdown">
                            <button className="btn btn-default dropdown-toggle btn-template-dropdown" type="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            </button>
                            <div className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                {relatedTemplateList.length > 0 && relatedTemplateList.map((template: AppStore.RelatedTemplates) => {
                                    return <button className="dropdown-item" type="button" onClick={(e) => btnRelatedTempltesClick(e, template)}>{template.TemplateAssociated[0].Key}</button>
                                })}
                            </div>
                        </div>
                    }
                </div>
            </React.Fragment>
            :
            <React.Fragment></React.Fragment>
    );
}

//export default connect()(ItemEdit);

export default connect((state: ApplicationState) => state.appStore,
    AppStore.layoutActionCreators
)(ItemEdit);